<template>
     <div class="is-inline-block">
        <div v-if="!prevDrag">
             <drop class="is-inline-block" style="min-width: 20" @dragenter="insertDragEnter" @dragleave="insertDragLeave" @drop="insertDrop(subBundle.id, theInd, ...arguments)" @dragend="insertDragEnd">
                 <div v-if="showIt" ref="dropMarker" class="subLabelDropMarker"><i class="fa fa-arrow-down"></i></div>&nbsp;
             </drop>
             <drop  class="is-inline subLabelContainer"  
                @drop="subBundleDrop(subBundle.id, theInd, subBundle.aliasTgtId, ...arguments)" @dragenter="subBundleDragEnter" @dragleave="subBundleDragLeave" @dragend="dragEnd">
                   
                    <div  class="is-inline" @click="loadSub(theInd)">
                    
                    <!-- For normal bundles these are draggable -->
                    <div class="is-inline" v-if="$route.path != '/sb'"> 
                        <drag class="is-inline"
                            @dragstart="dragStart" 
                            :transfer-data="{
                                bundleId: bundleId, 
                                cardId: null, 
                                cardsIndex: null, 
                                type: 'list', 
                                draggedId: subBundle.id, 
                                fromSub: true, 
                                theInd: theInd, 
                                aliasTgtId: subBundle.aliasTgtId, 
                                collabId: subBundle.collabId}">
                                
                                <div class="subBundleLabel" ref="subLabel">
                                    
                                    <span class="pointerEventsOff">{{subBundle.listName}} </span>
                                    <div v-if="$root.app.userAttrs.sub != subBundle.id_cog && subBundle.id_cog" class="is-inline-block notMineSubBundle has-text-centered">
                                        <div>{{initials}}</div>
                                    </div>
                                    
                                     <div v-if="hasChildren && !$parent.$parent.upd" class="is-inline subLabelDownArrow" @click="openSubDropdown(theInd, ...arguments)">
                                        <i  class="fa fa-sort-down"></i>
                                    </div>
                                    <span style="font-size: 19px; position: relative; top: 3px; font-weight: 300">&nbsp;|</span>
                                </div>
                               
                        </drag>
                    </div>
    
                     <!-- For shared bundle view these are not draggable -->
                    <div class="is-inline" v-if="$route.path == '/sb'">
                        <div class="is-inline">
                            <div class="pointerEventsOff subBundleLabel" :class="{bundleSelectedForImport: selectedForImport}" ref="subLabel">
                                
                                <span class="pointerEventsOff">{{subBundle.listName}}&nbsp;</span>

                                <span style="font-size: 19px; position: relative; top: 3px; font-weight: 300">&nbsp;|</span>
                            </div>
                        </div>
                    </div>
        
                   
        
                    <div class="subBundleDropDown hideIt" :class="{subBundleDropDownShared: $route.path == '/sb'}" ref="subDropdowns">
                        <div v-for="(child, i) in subBundle.children" :key="i" @click.prevent="loadSubFromDropdown(child, theInd, {listName: subBundle.listName, id: subBundle.id}, ...arguments)">{{child.listName}}</div>
                    </div>
                        
                    </div>
              
            </drop>
         </div>


        <!--- if in public bundle --->
        <div v-if="prevDrag" style="margin-right: 5px">
          
             <div  class="is-inline subLabelContainer">
                    <div  class="is-inline" @click="loadSub(theInd)">
                    
                    <!-- For normal bundles these are draggable -->
                    <div class="is-inline" v-if="$route.path != '/sb'"> 
                        <div class="is-inline">
                                <div class="subBundleLabel" ref="subLabel">
                                    <!-- <b  class="has-text-coolGreen pointerEventsOff">:: </b> -->
                                    <span class="pointerEventsOff">{{subBundle.listName}}</span>
                                  
                                  <!--   <div v-if="$root.app.userAttrs.sub != subBundle.id_cog && subBundle.id_cog" class="is-inline-block notMineSubBundle has-text-centered">
                                        <div>{{initials}}</div>
                                    </div> -->
                                     <div v-if="hasChildren && !$parent.$parent.upd" class="is-inline subLabelDownArrow" @click="openSubDropdown(theInd, ...arguments)">
                                        <i  class="fa fa-sort-down"></i>
                                    </div>
                                      <span style="font-size: 19px; position: relative; top: 3px; font-weight: 300">&nbsp;|</span>
                                </div>
                               
                        </div>
                    </div>
    
                     <!-- For shared bundle view these are not draggable -->
                    <div class="is-inline" v-if="$route.path == '/sb'">
                        <div class="is-inline">
                            <div class="pointerEventsOff subBundleLabel" :class="{bundleSelectedForImport: selectedForImport}" ref="subLabel">
                                <!-- <b  class="has-text-coolGreen pointerEventsOff">:: </b> -->
                                <span class="pointerEventsOff">{{subBundle.listName}}&nbsp;</span>
                                <span style="font-size: 19px; position: relative; top: 3px; font-weight: 300">&nbsp;|</span>
                            </div>
                        </div>
                    </div>
        
                   
        
                    <div class="subBundleDropDown hideIt top-20" :class="{subBundleDropDownShared: $route.path == '/sb'}" ref="subDropdowns">
                        <div v-for="(child, i) in subBundle.children" :key="i" @click.prevent="loadSubFromDropdown(child, theInd, {listName: subBundle.listName, id: subBundle.id}, ...arguments)"><span class="has-text-coolGreen"><b>::</b></span>{{child.listName}}</div>
                    </div>
                        
                    </div>
              
            </div>
         </div>
    </div>
</template>

<script>

import { Drag, Drop } from 'vue-drag-drop'
import { AZEventBus } from '../components/AZEventBus'



export default {
    props: {
        subBundle: {
            type: Object,
            default: function(){
                return {id: 0}
            }
        },
        prevDrag: {
            type: Boolean,
            default: false
        },
        theInd: Number,
        bundleId: Number, //parent
        aliasTgtId: Number //parent
    },

    components: {Drag, Drop},

    data: function(){
        return {
            counter: 0,
            insertCounter: 0,
            showIt: false,
            selectedForImport: false
        }
    },

    mounted: function(){
        var self = this;

        AZEventBus.$on('closeAllMenus', self.addHideIt)
    },

    beforeDestroy: function(){
        var self = this;
        AZEventBus.$off('closeAllMenus', self.addHideIt)
    },

    methods: {
        

        addHideIt: function(){
            if(this.$refs.subDropdowns)
                this.$refs.subDropdowns.classList.add('hideIt')
        },
       
        loadSub: function(theInd){
           
            this.$parent.loadSub(this.subBundle, theInd)
        },
        openSubDropdown: function(ind, event){
            event.stopPropagation()
            this.$refs.subDropdowns.classList.toggle('hideIt')
            this.$refs.subDropdowns.style.left = event.target.parentElement.parentElement.parentElement.offsetLeft + 'px'
        },
        loadSubFromDropdown: function(b, ind, parent){
            event.stopPropagation()
            this.$parent.riseSubLabel(b, ind)
        },

        dragStart: function(data, e){        
            this.$root.app.bundleDraggerText = this.subBundle.listName   
            var img = document.getElementById('bundleDraggerSmall')
            e.dataTransfer.setDragImage(img, 0, 30); 
        },

        dragEnd: function(){
            this.$refs.subLabel.classList.remove('has-background-coolGreen')
            this.counter = 0;
        },

        subBundleDragEnter: function(data, event){

           if(this.counter == 0){
                this.$refs.subLabel.classList.add('has-background-coolGreen');    
           }
           this.counter++;
        },

        subBundleDragLeave: function(){
           this.counter--;
           if(this.counter == 0){
              this.$refs.subLabel.classList.remove('has-background-coolGreen')
           }
        },

        insertDragEnd: function(){
            this.showIt = false;
            this.insertCounter = 0;
            this.$parent.$refs.subBundleList.classList.remove('left-5')
        },

        insertDragEnter: function(data, event){

            

            
            var self = this

           if(this.insertCounter == 0){
                if(data.type == 'list'){
                    this.$parent.$refs.subBundleList.classList.add('left-5')
                    this.showIt = true
                }
                
           }
           this.insertCounter++;
        },

        insertDragLeave: function(){
           this.insertCounter--;
           if(this.insertCounter == 0){
              this.$parent.$refs.subBundleList.classList.remove('left-5')
              this.showIt = false;
           }
        },
        
        insertDrop: async function(id, index, data, event){
            

            this.showIt = false
            this.$parent.$refs.subBundleList.classList.remove('left-5')
            this.insertCounter = 0;


            if(data.type == 'list'){

                if(data.draggedId == this.subBundle.id) {
                    return
                }

                if(data.collabId != this.$parent.conts.collabId && (data.collabId && this.$parent.conts.collabId)){
                    this.$root.app.showModalOK({message: "You cannot put a collab bundle into another collab bundle."})
                    return;
                }

                if(data.collabId != this.$parent.conts.collabId && this.$parent.conts.collabId){
                    this.$root.app.doShowModal('ModalDragbtoc', {message: 'You are dragging a bundle into a collab bundle. Would you like to move it, or create a copy of it.', callBack: this.doDragBIntoCollab, payload: {id:id, index: index, aliasTgtId: this.$parent.conts.aliasTgtId, collabId: this.subBundle.collabId, targetId: this.$parent.conts.aliasTgtId || this.$parent.conts.id,  data: data, event: event, branch: this.$parent.conts.branch}})
                    return
                } else if(data.collabId != this.$parent.conts.collabId && !this.$parent.conts.collabId){

                    if(data.fromSub == false){
                         this.$root.app.showModalOK({message: 'Putting collab bundles into other bundles is restricted for now. Stay tuned.'})
                         return
                    } else {
                         if(await this.$root.app.checkDescendantsForForeign(data.draggedId)){
                            this.$root.app.showModalOK({message: 'This bundle has content contributed by other collab members. Please remove this content before moving the bundle out of the collab.'})
                            return
                        }
                      /*   this.$root.app.showModalOK({message: 'Removing bundles from collab bundle coming soon. Stay tuned'})
                        return */
                    }
                    
                }

                let parentCheck = this.$parent.breadCrumbs.findIndex(e => {
                    return e.id == data.draggedId
                })

                if(parentCheck > -1){
                    this.$root.app.showModalOK({message:'You may not move a bundle into one of its children.'})
                    return
                }

                let movedBundle = this.$root.app.bundles.findIndex((e) => {
                    return e.id == data.draggedId
                })

                var copyOfBundle,
                copyOfBundle = this.$root.app.bundles[movedBundle] //JSON.parse(JSON.stringify(this.$root.app.bundles[movedBundle]))

                if(this.subBundle.branch[0] == copyOfBundle.id){
                    this.$root.app.showModalOK({message: "A root bundle cannot be a child of itself"})
                    return
                }
         

                if(data.fromSub){
                    this.$root.app.bundleMover(data.bundleId, this.bundleId, this.theInd, copyOfBundle, this.$root.app, this.subBundle.branch, null, null, null, this.aliasTgtId, this.subBundle.collabId);

                } else { 
                    let rootId = copyOfBundle.branch[0]
                    copyOfBundle = this.$root.app.bundles.find(e => {
                        return e.id == rootId;
                    }) 
           
                    let draggedListIndex = this.$root.app.treeNoInbox.findIndex(e => {
                        return e.id == rootId;
                    })

                    
                    this.$root.app.bundleMover('root', this.bundleId, this.theInd, copyOfBundle, this.$root.app, this.subBundle.branch, draggedListIndex, null, null, this.aliasTgtId, this.subBundle.collabId);
                }
            }

        },

        subBundleDrop: async function(id, index, aliasTgtId, data, event){
            this.$refs.subLabel.classList.remove('has-background-coolGreen')
            this.counter = 0
             if(data.type == 'card'){
               

                let fromBundleId = data.bundleId
                let cardId = data.cardId
                let cardsIndex = data.cardsIndex
                let toBundleId = id
                let before = -1;
                let after = -1;

                /* let bInd = this.$root.app.bundles.findIndex(e => {
                    return e.id == id
                })

                if(this.$root.app.bundles[bInd].items.length)
                    after = this.$root.app.bundles[bInd].items[0].entryId;
                else
                    after = false */

                if((this.$root.app.cards[data.cardsIndex].id_cog != this.$root.app.userAttrs.sub) && (data.parentCollabId != this.$parent.conts.parentCollabId)){
                   this.$root.app.showModalOK({message: 'This card was not contributed to this collaboration by you. You cannot move it outside this collab bundle. Make a copy instead?', 
                                            callBack: this.$root.app.copyCardCallback, 
                                            payload: {url: '', cardsIndex: data.cardsIndex, callApi: false, caller: this, bundleId: this.subBundle.id, before: before, after: after, fromBundleId: data.trueFromBundleId}})
                    return
                } 

                let self = this
                function callBack(){
                    //self.$parent.sort()
                    //self.dragging = false
                }

                this.$root.app.cardMover(fromBundleId, cardId, toBundleId, before, after, this.$root.app, callBack, cardsIndex, aliasTgtId)

            } else if(data.type == 'list') {

                if(data.draggedId == this.subBundle.id) {
                    return
                }

                if(data.collabId != this.subBundle.collabId && (data.collabId && this.subBundle.collabId)){
                    this.$root.app.showModalOK({message: "You cannot put a collab bundle into another collab bundle."})
                    return;
                }

                if(data.collabId != this.subBundle.collabId && this.subBundle.collabId){
                    this.$root.app.doShowModal('ModalDragbtoc', {message: 'You are dragging a bundle into a collab bundle. Would you like to move it, or create a copy of it.', 
                                callBack: this.doDragBIntoCollab, 
                                payload: {id: id, index: 0, aliasTgtId: aliasTgtId, targetId: this.subBundle.aliasTgtId || this.subBundle.id, collabId: this.subBundle.collabId,  data: data, event: event, branch: this.subBundle.branch}})
                    return
                } else if(data.collabId != this.subBundle.collabId && !this.subBundle.collabId){
                    if(data.fromSub == false){
                         this.$root.app.showModalOK({message: 'Putting collab bundles into other bundles is restricted for now. Stay tuned.'})
                         return
                    } else {
                        if(await this.$root.app.checkDescendantsForForeign(data.draggedId)){
                            this.$root.app.showModalOK({message: 'This bundle has content contributed by other collab members. Please remove this content before moving the bundle out of the collab.'})
                            return
                        }
                        /* this.$root.app.showModalOK({message: 'Removing bundles from collab bundle coming soon. Stay tuned'})
                        return */
                    }
                }

                let parentCheck = this.$parent.breadCrumbs.findIndex(e => {
                    return e.id == data.draggedId
                })

                if(parentCheck > -1){
                     this.$root.app.showModalOK({message:'You may not move a bundle into one of its children.'})
                    return
                }
                
                let movedBundle = this.$root.app.bundles.findIndex((e) => {
                    return e.id == data.draggedId
                })

                var copyOfBundle,
                copyOfBundle = this.$root.app.bundles[movedBundle] //JSON.parse(JSON.stringify(this.$root.app.bundles[movedBundle]))
         
                if(this.subBundle.branch[0] == copyOfBundle.id){
                    this.$root.app.showModalOK({message: "A root bundle cannot be a child of itself"})
                    return
                }

                if(data.fromSub){
                    this.$root.app.bundleMover(data.bundleId, this.subBundle.id, 0, copyOfBundle, this.$root.app, this.subBundle.branch, null, null, this.bundleId, this.subBundle.aliasTgtId, this.subBundle.collabId );
                } else { 

                    let rootId = copyOfBundle.branch[0]
                    copyOfBundle = this.$root.app.bundles.find(e => {
                        return e.id == rootId;
                    }) 
           
                    let draggedListIndex = this.$root.app.treeNoInbox.findIndex(e => {
                        return e.id == rootId;
                    })

                    this.$root.app.bundleMover('root', this.subBundle.id, 0, copyOfBundle, this.$root.app, this.subBundle.branch, draggedListIndex, null, null, this.subBundle.aliasTgtId, this.subBundle.collabId);
                }
            }
        },
        doDragBIntoCollab: function(payload){
          
            var self = this;

            function w(d){
                self.$root.app.InitialDataLoad(true)
            }

            function n(){

            }
            if(payload.what == 2){
                this.$root.app.apiClient.put('subs/data/copybintocollab', {id: payload.data.draggedId, collabId: payload.collabId, index: payload.index, targetId: payload.targetId, parentId: payload.data.bundleId || 'root'}, w, n)
            }
            
            this.$root.app.closeModal()
        }
    },
    computed: {
        initials: function(){
            var val = this.subBundle.id_cog
            for(var i=0; i < this.$root.app.groupMembers.length; i++){
                if(this.$root.app.groupMembers[i].id_customer == val){
                    return this.$root.app.groupMembers[i].fName.charAt(0).toUpperCase() + this.$root.app.groupMembers[i].lName.charAt(0).toUpperCase()
                }
            }
            return ""
        },
        hasChildren: function(){
            if(this.subBundle.children){
                return this.subBundle.children.length
            }
            return false
        }
    }
}

</script>